import server from "./server";

export const getPersonnelsApi = async () => {
  const response = await server().get("/personnels");
  return response.data;
};

export const getSinglePersonnelApi = async (id) => {
  const response = await server().get(`/personnels/${id}`);
  return response.data;
};

export const addPersonnelApi = async (payload) => {
  const response = await server().post("/personnels", payload);
  return response.data;
};

export const editPersonnelApi = async ({ id, data }) => {
  const response = await server().put(`/personnels/${id}`, data);
  return response.data;
};

export const deletePersonnelApi = async (id) => {
  const response = await server().delete(`/personnels/${id}`);
  return response.data;
};
